var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-btn',{staticClass:"wall-action-btn px-0",class:{
			'accent lighten-2' : _vm.pinned,
			'grey--text text--darken-2' : _vm.pinned && !_vm.active,
			'text--darken-1' : !_vm.colorOnHover && hover,
			'success--text success lighten-3' : _vm.active && !_vm.classesOnActive,
			'grey--text' : (!_vm.active && !hover),
			'white' : !_vm.active && !_vm.pinned,
			[ _vm.colorOnHover ]: _vm.colorOnHover && hover,
			[ _vm.classesOnActive ] : _vm.active && _vm.classesOnActive,
		},attrs:{"elevation":"0","height":"40","plain":_vm.plain,"loading":_vm.saving},on:{"click":_vm.action}},[(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e(),(_vm.text)?_c('span',{staticClass:"d-none d-md-block ml-2"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.badge)?_c('div',{staticClass:"badge ml-1"},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }